import {
  tns
} from '../../../../node_modules/tiny-slider/src/tiny-slider';

function chooseUsSlider () {
  const slider = document.querySelector('#chooseUsSlider');

  if (slider) {
    return tns({
      container: '#chooseUsSlider',
      mode: 'carousel',
      items: 2,
      gutter: 0,
      controls: true,
      controlsPosition: 'bottom',
      controlsText: [
        'Vorige',
        'Volgende'
      ],
      nav: false,
      responsive: {
        667: {
          items: 3
        },
        768: {
          items: 4
        }
      },
      speed: 400,
      loop: false
    });
  }
}

chooseUsSlider();
